import React, { FC } from 'react'
import _ from 'lodash'
import { Order } from '../../types'
import ListGroup from '../ListGroup'
import OrderSummaryListItem from './OrderSummaryListItem'
import { format, parseISO } from 'date-fns'
import { Config } from '../../common'

interface Props {
  orders: Order[]
  selected?: Order
  onSelect?: (order: Order) => void
}

const OrderSummaryList: FC<Props> = ({ orders, selected, onSelect }) => {
  if (orders.length === 0) {
    return null
  }

  const groups = _.groupBy(orders, (order: Order) => {
    return format(parseISO(order.created_at), Config.GroupHeaderDateFormat)
  })

  return (
    <ListGroup.Items>
      {Object.entries(groups).map(([date, orders], idx) => {
        return (
          <React.Fragment key={idx}>
            <ListGroup.Item key={date} data-key={date} className="summary__list-header">
              {date}
            </ListGroup.Item>
            {orders.map((order: Order) => (
              <ListGroup.Item hover key={`${order.id}-list-group-item`} isActive={selected?.id === order.id}>
                <OrderSummaryListItem
                  key={`${order.id}-summary-list-item`}
                  onClick={onSelect}
                  order={order}
                  active={selected?.id === order.id}
                />
              </ListGroup.Item>
            ))}
          </React.Fragment>
        )
      })}
    </ListGroup.Items>
  )
}

export default OrderSummaryList
